import { format, isBefore, isEqual, isAfter, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

/**
 * 야놀자 타임 기간인지 확인하는 함수(00:00:00 ~ 01:59:59)
 * ! 국내숙소만 해당
 */
export const isInYaTime = (time: Date): boolean => {
  const seoulTime = toZonedTime(time, 'Asia/Seoul');

  const currentDate = format(seoulTime, 'yyyy-MM-dd');
  const startTime = parseISO(`${currentDate}T00:00:00`);
  const endTime = parseISO(`${currentDate}T02:00:00`);

  return (isEqual(seoulTime, startTime) || isAfter(seoulTime, startTime)) && isBefore(seoulTime, endTime);
};
